import DataTable from 'react-data-table-component';
import React from 'react'
import { FaList, FaFileSignature, FaArchive, FaExclamationTriangle, FaCheck, FaCheckCircle } from "react-icons/fa";
import Addprinting from './addprinting';

const columns = [
    {
        name: 'TDS code',
        grow: 1,
        sortable: true,
        selector: row => row.tdscode,
    },
    {
        name: 'V',
        grow: 0.1,
        selector: row => row.revision,
    },
    {
        name: 'Journal Type',
        grow: 1,
        selector: row => <div>
            <div>{row.journaltype}</div>
            <div style={{ color: "red" }}>Create by: ({row.createbyName})</div>
        </div>,
    },
    {
        name: 'customer / product',
        grow: 1.5,
        selector: row => <div>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
        </div>,
    },
    {
        name: 'film code',
        selector: row => row.filmcode,
    },
    {
        name: 'confirm job',
        grow: 1,
        selector: row => <div>{row.statusConfirm == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle />Approve</label>}</div>,
    },
    {
        name: 'createdate',
         grow: 1,
        selector: row => row.createdate,
    },
    {
        name: 'Action',
        grow: 1,
        cell: row => <Addprinting codeId={row.tdscode} journalId={row.journalId} stateflow={row.stateflow} />,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Journalprintingtable = (datatable) => {
    var dataresult = datatable.datatable;


    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Journalprintingtable